export const reviewTypes = {
    REV_TOUR_PACKAGE: 'REV_TOUR_PACKAGE',
    REV_DESTINATION: 'REV_DESTINATION',
    REV_ATTRACTION: 'REV_ATTRACTION',
    REV_ACTIVITY: 'REV_ACTIVITY',
    REV_EVENT: 'REV_EVENT',
};